import React from "react";
import { useTranslation } from "react-i18next";
import { translationConstants } from "../../../constants";

const TimezoneDisplayText = () => {
  const { t } = useTranslation();
  return (
    <div className="timezone-display-text">{`*${t(
      translationConstants.TIMEZONE_DISPLAY_ON_GRID
    )}`}</div>
  );
};

export default TimezoneDisplayText;
